import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import { ChatAiAssistState } from '../../hooks/admin/useChatAiAssist';

interface ChatAiAssistTriggerProps {
  assist: ChatAiAssistState;
  lastInvestorMessagePresent: boolean;
}

export const ChatAiAssistTrigger: React.FC<ChatAiAssistTriggerProps> = ({
  assist,
  lastInvestorMessagePresent,
}) => (
  <Tooltip
    title={
      !lastInvestorMessagePresent
        ? 'Vera assist is available once the investor has sent a message'
        : assist.isStale
          ? 'New investor message — open Vera assist to refresh'
          : assist.latestResult && assist.mode === 'closed'
            ? 'Open saved Vera assist (admin only)'
            : 'Get admin-only Vera assist for the latest investor message'
    }
  >
    <span>
      <IconButton
        aria-label="Vera assist for admin reply"
        onClick={() => {
          void assist.openPanel();
        }}
        disabled={!assist.canInvoke || assist.loading}
        size="small"
        sx={{
          border: '1px solid #ddd',
          borderRadius: 1,
          width: 40,
          height: 40,
          position: 'relative',
        }}
      >
        {assist.loading ? <CircularProgress size={18} /> : <AutoAwesomeIcon fontSize="small" />}
        {assist.isStale && (
          <Box
            sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: 'warning.main',
            }}
          />
        )}
      </IconButton>
    </span>
  </Tooltip>
);
